import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { EntityFollowButton } from "~/components/entity-follow-button";
import { TopicLink } from "~/components/topic/topic-link";
import { StyledEntityLink } from "~/components/topic/topic-link/styles";

export const StyledTopicLink = styled(TopicLink)`
  word-break: break-word;
`;

// Item
export const TopicSeparator = styled.span`
  padding-block: 0;
  padding-inline: 8px;

  color: #bbbbbb;
  font-size: 16px;
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)`
  margin-inline-start: 6px;
`;

export const Item = styled.h2`
  display: flex;
  flex: none;
  flex-flow: row nowrap;
  align-items: center;

  max-inline-size: 100%;

  ${StyledEntityLink} {
    color: #bbbbbb;
    &:hover {
      color: #000000;
    }
  }
`;

export const MainItem = styled(Item)`
  flex-basis: 100%;

  max-inline-size: 100%;
`;

export type ArticleTopicsContainerProps = {
  $variant?: "light" | "dark";
};
export const ArticleTopicsContainer = styled.div<ArticleTopicsContainerProps>`
  display: flex;
  flex-flow: row wrap;
  gap: 8px;

  padding: 16px;

  background: #fafafa;

  ${props =>
    props.$variant === "dark"
      ? css`
          background: #111111;
        `
      : null}

  ${MainItem}, ${Item} {
    ${StyledEntityLink}, {
      ${props =>
        props.$variant === "dark"
          ? css`
              color: #666666;
              &:hover {
                color: #ffffff;
              }
            `
          : null}
    }
  }
`;
